<template>
  <div class="app">
    <DefaultHeader />
    <div class="app-body">
      <AppSidebar fixed>
        <SidebarHeader />
        <SidebarForm />

        <SidebarNav v-if="userRole=='admin' && (userType== 0 || userType== 1)" :navItems="nav"></SidebarNav>
        <SidebarNav v-else-if="userRole=='user' && userType == 0 " :navItems="usernav"></SidebarNav>
        <SidebarNav v-else-if="userRole=='user' && userType == 1 " :navItems="partnernav"></SidebarNav>
        <SidebarFooter />
        <!-- <SidebarMinimizer /> -->
      </AppSidebar>
      <main class="main">
        <Breadcrumb :list="list" />
        <div class="container-fluid">
          <router-view></router-view>
        </div>
      </main>
      <AppAside fixed>
        <!--aside-->
        <DefaultAside />
      </AppAside>
    </div>
    <DefaultFooter />
  </div>
</template>

<script>
import nav from "@/_nav";
import usernav from "@/userNav";
import partnernav from "@/partnernav";
import {
  Sidebar as AppSidebar,
  SidebarFooter,
  SidebarForm,
  SidebarHeader,
  SidebarMinimizer,
  SidebarNav,
  Aside as AppAside,
  Breadcrumb
} from "@coreui/vue";
import DefaultAside from "./DefaultAside";
import DefaultHeader from "./DefaultHeader";
import DefaultFooter from "./DefaultFooter";

export default {
  name: "DefaultContainer",
  components: {
    AppSidebar,
    AppAside,
    Breadcrumb,
    DefaultAside,
    SidebarForm,
    SidebarFooter,
    SidebarHeader,
    SidebarNav,
    SidebarMinimizer,
    DefaultFooter,
    DefaultHeader
  },
  data() {
    return {
      nav: nav.items,
      usernav:usernav.items,
      partnernav:partnernav.items,
      userType: localStorage.getItem("usrType"),
      userRole: localStorage.getItem("role"),
    };
  },
  computed: {
    name() {
      return this.$route.name;
    },
    list() {
      return this.$route.matched.filter(
        route => route.name || route.meta.label
      );
    }
  }
};
</script>
